var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "#115C72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.5C6.41421 0.5 6.75 0.835786 6.75 1.25V9.18934L8.46967 7.46967C8.76256 7.17678 9.23744 7.17678 9.53033 7.46967C9.82322 7.76256 9.82322 8.23744 9.53033 8.53033L6.53033 11.5303C6.23744 11.8232 5.76256 11.8232 5.46967 11.5303L2.46967 8.53033C2.17678 8.23744 2.17678 7.76256 2.46967 7.46967C2.76256 7.17678 3.23744 7.17678 3.53033 7.46967L5.25 9.18934V1.25C5.25 0.835786 5.58579 0.5 6 0.5ZM0.75 11.75C1.16421 11.75 1.5 12.0858 1.5 12.5V14H10.5V12.5C10.5 12.0858 10.8358 11.75 11.25 11.75C11.6642 11.75 12 12.0858 12 12.5V14C12 14.8284 11.3284 15.5 10.5 15.5H1.5C0.671573 15.5 0 14.8284 0 14V12.5C0 12.0858 0.335786 11.75 0.75 11.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export-icon.c93e54824a43107212aa21d5ad83a578.svg";
export { ForwardRef as ReactComponent };